/**
 * @generated SignedSource<<255f3d5c29bf7068dc1c173476646643>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSageIntacctTimesheetsInput = {
  People?: ReadonlyArray<SageTimesheetInput | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SageTimesheetInput = {
  SageEmployeeId?: string | null;
  StartDate?: string | null;
  Name?: string | null;
  TimeRegs?: ReadonlyArray<SageTimesheetEntryInput | null> | null;
};
export type SageTimesheetEntryInput = {
  TimeRegId?: string | null;
  Date?: string | null;
  Hours?: number | null;
  Billable?: boolean | null;
  Notes?: string | null;
  SageProjectId?: string | null;
  SageTaskId?: string | null;
  SageLocationId?: string | null;
  SageDepartmentId?: string | null;
};
export type CreateSageIntacctTimesheetsMutation$variables = {
  input: CreateSageIntacctTimesheetsInput;
};
export type CreateSageIntacctTimesheetsMutation$data = {
  readonly createSageIntacctTimesheets: {
    readonly viewer: {
      readonly id: string;
    } | null;
  } | null;
};
export type CreateSageIntacctTimesheetsMutation = {
  variables: CreateSageIntacctTimesheetsMutation$variables;
  response: CreateSageIntacctTimesheetsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSageIntacctTimesheetsPayload",
    "kind": "LinkedField",
    "name": "createSageIntacctTimesheets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageIntacctTimesheetsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageIntacctTimesheetsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4adbe3e6ec0ad323e6a2153c5664473b",
    "id": null,
    "metadata": {},
    "name": "CreateSageIntacctTimesheetsMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageIntacctTimesheetsMutation(\n  $input: CreateSageIntacctTimesheetsInput!\n) {\n  createSageIntacctTimesheets(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb49b2d39ddecd8e3500e65268b6fdae";

export default node;
